/**
 * Su mercato/URL italiano, applica .goodbadugly alle sezioni editoriali
 * (stesso effetto del custom_class quando il contesto mercato non lo passa).
 */
(function () {
  function isItalianLocale() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (lang === 'it' || lang.indexOf('it-') === 0) return true;
    var p = window.location.pathname || '';
    return /\/(it|it-it)(\/|$)/i.test(p);
  }

  function applyGoodbadugly() {
    if (!isItalianLocale()) return;
    var ids = ['media_with_content_wHpEGg', 'media_with_content_Dnb6rW'];
    ids.forEach(function (fragment) {
      var wrap = document.querySelector('[id*="' + fragment + '"]');
      if (!wrap) return;
      var inner = wrap.querySelector('.media-with-content');
      if (inner && !inner.classList.contains('goodbadugly')) {
        inner.classList.add('goodbadugly');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyGoodbadugly);
  } else {
    applyGoodbadugly();
  }

  document.addEventListener('shopify:section:load', applyGoodbadugly);
})();
